
import React from 'react';
import './Values.css';

const valuesData = [
  { icon: "https://sendbird.imgix.net/cms/loop.svg", title: "Endless tenacity", description: "We don’t stop at obstacles. We adapt, solve, and persist until the job is completely done in a remarkable way." },
  { icon: "https://sendbird.imgix.net/cms/user-heart.svg", title: "Customers first", description: "We succeed only if our customers do. Their needs come before our personal preferences, plans, or egos." },
  { icon: "https://sendbird.imgix.net/cms/bolt.svg", title: "Drive velocity", description: "Set clear directions, move fast, and stay fast. Velocity compounds." },
  { icon: "https://sendbird.imgix.net/cms/medal.svg", title: "Always raise the bar", description: "Good is the enemy of great. We keep learning, pushing ourselves, and striving to exceed even our own highest standards of quality." },
  { icon: "https://sendbird.imgix.net/cms/lightbulb-alt.svg", title: "High-agency & exothermic leadership", description: "We take responsibility, drive action, and energize everyone around us. Leadership is a habit, not a title." },
  { icon: "https://sendbird.imgix.net/cms/screen-users_2025-05-13-230954_qfcz.svg", title: "Own collective outcomes", description: "I own the success of the entire team. I fix problems we didn’t create, I help others without being asked, and I do whatever it takes to ensure our entire group wins." },
  { icon: "https://sendbird.imgix.net/cms/globe_2025-05-13-231022_haln.svg", title: "Global citizenship", description: "We build with a global mindset. We respect diverse cultures, think beyond borders, and consider the broader impact of our decisions. We act locally, but with the awareness and responsibility of a connected world." }
];

function Values() {
  return (
    <section className="values-section">
      <div className="values-container">
        <h3 className="values-main-title">Our 7 core values</h3>
        <div className="values-grid">
          {valuesData.map((value, index) => (
            <div key={index} className="value-card">
              <img src={value.icon} alt="" className="value-icon" />
              <h4 className="value-title">{value.title}</h4>
              <p className="value-description">{value.description}</p>
            </div>
          ))}
           <div className="value-card-image">
            <img src="https://sendbird.imgix.net/cms/sendbird-office-photo.jpg?wm=webp" alt="Sendbird Office" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Values;